import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { ProductModel, RecommendationModel } from 'Pages/orders'
import { RequestParams, ResponseCatalog } from 'Models'

export const productsApi = {
	getRecommendations: async (params: { okved: string; rbidos_type: string }) => {
		const res = await axiosDS().get<ResponseCatalog<RecommendationModel>>(
			urls.cabinet.recommendations,
			{ params }
		)
		return res.data
	},
	getProducts: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ProductModel>>(urls.cabinet.products, {
			params,
		})
		return res.data
	},
}
